import { memo } from "react";
import { EsignRuleForm } from "./EsignRuleForm";

export const BasicData = memo(() => {
  return <EsignRuleForm />;
});
